'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLaptop(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M3.347 10.993h9.306c.875 0 1.347-.456 1.347-1.354V4.206c0-.898-.472-1.356-1.347-1.356H3.347C2.467 2.85 2 3.308 2 4.206V9.64c0 .898.466 1.354 1.347 1.354zm10.01.857H2.643a.643.643 0 100 1.286h10.714a.643.643 0 000-1.286z", fill: "currentColor" }))));
}

module.exports = SvgLaptop;
//# sourceMappingURL=Laptop.js.map
